const getTodayPreviewItems = ({paymentState, todayItems, is5Order}) => {
  const isAusNZ = ['AU', 'NZ'].includes(paymentState.paymentInfo.country)
  if (is5Order) {
    const {
      centers = [],
      apps = [],
      oneTimes = [],
    } = paymentState.paymentInfo.paymentPreview
    const previewItems = [...centers, ...apps, ...oneTimes]
    const todayPreviewItems = previewItems.map(item => {
      const {addonCode, planCode, name, quantity, subtotal, discount, tax} =
        item
      const relativeItem =
        (addonCode && todayItems.find(i => i.code === addonCode)) ||
        todayItems.find(i => i.code === planCode)
      const isAusNZ = ['AU', 'NZ'].includes(paymentState.paymentInfo.country)
      const isSocialAds = relativeItem?.name
        .toLowerCase()
        .includes('social ads')
      let unitAmount = !isAusNZ ? subtotal : subtotal + tax
      if (isSocialAds) {
        unitAmount = relativeItem.currency.unitAmount
      }
      return {
        ...relativeItem,
        code: addonCode || planCode,
        name: name || relativeItem.name,
        quantity,
        currency: {
          unitAmount,
          currency: relativeItem?.currency.currency,
        },
        discount,
        transitionApplies: discount > 0 ? true : false,
      }
    })

    // The Recurly preview only lists what is charged today, so items the
    // account already owns (upgrade flow) are absent from it. Append them so
    // Due Today still lists them — the renderer shows them as "Included" at $0.
    const previewCodes = new Set(todayPreviewItems.map(({code}) => code))
    const includedExistingItems = todayItems.filter(
      item => item.isExisting && !previewCodes.has(item.code),
    )
    return [...todayPreviewItems, ...includedExistingItems]
  } else {
    const previewSubscriptions =
      paymentState.paymentInfo.paymentPreview?.subscriptions ?? []
    const amountSubscriptions = paymentState?.subscriptions || []
    const todayPreviewItems = previewSubscriptions.flatMap(item => {
      const {planCode, name, quantity, discount, addons} = item
      const amountItem = amountSubscriptions?.find(s => s.planCode === planCode)
      const total = amountItem ? amountItem.total : item.total
      const subtotal = amountItem ? amountItem.subtotal : item.subtotal
      if (addons && addons.length > 0) {
        return addons.map(addon => {
          const amountAddon = amountItem?.addons?.find(
            a => a.planCode === addon.planCode,
          )
          return {
            code: addon.planCode,
            name: addon.name,
            quantity: addon.quantity,
            currency: {
              unitAmount: isAusNZ
                ? amountAddon?.total ?? addon.total
                : amountAddon?.subtotal ?? addon.subtotal,
            },
            discount: addon.discount,
            transitionApplies: addon.discount > 0 ? true : false,
          }
        })
      }
      return [
        {
          code: planCode,
          name: name,
          quantity,
          currency: {
            unitAmount: isAusNZ ? total : subtotal,
          },
          discount,
          transitionApplies: discount > 0 ? true : false,
        },
      ]
    })
    return todayPreviewItems
  }
}

export {getTodayPreviewItems}
